import { React, computed, findDOMNode, observable, action, Fragment } from '@api';

import { Tooltip } from '@material-ui/core';
import { Link } from '@material-ui/icons';
import {configs, Stores, globalStores} from '@stores'
import * as css from './ExternalPlmLink.css'
import {observer} from 'mobx-react'
import { Tooltip2 } from '@api';

interface MyProps {
  plm?: 'centric' | string
  exId?: string
  id?: string
  libraryType: string
  isSeasonalLibrary?: boolean,
  data?: object
  stores: Partial<Stores>
}

@observer
export class ExternalPlmLink extends React.Component<MyProps> {
  static defaultProps = {
    plm: 'centric'
  }

  @computed get url() {
    const {props: {exId, plm}} = this,
      {ui: {settings: {c8: {sso}}}, authStore: {user: {sessionUrl}}} = globalStores

    if (!_.isEmpty(exId)) {
      switch (plm) {
        case 'centric': {
          return `${configs.config.centricURL}/WebAccess/home.html#URL=${exId}${sso ? `&SessionURL=${sessionUrl}` : ''}`
        }

        default: {
          console.error(`Unknown PLM system '${plm}'`)
        }
      }
    }
    return null;
  }

  @observable popup: 'linkToPlm' | 'publishNew' = null
  @observable.ref anchorEl: HTMLElement

  @action onOpenPlmPopup = (e) => {
    // prevent triggering table row click
    e.stopPropagation()

    this.popup    = 'linkToPlm'
    this.anchorEl = findDOMNode(this) as HTMLElement
  }

  @action onClosePopup = () => {
    this.popup = null
  }

  render() {
    const {
            url, popup, onOpenPlmPopup, onClosePopup,
            props: {exId, stores: {strings}}
          } = this
          
    return url
           ? <Tooltip2 content={strings.openInPLM}>
             <a target='_blank'
                href={url}
                onClick={e => e.stopPropagation()}>
               {exId}
             </a>
           </Tooltip2>
           : <Fragment>
             <Tooltip2 content={strings.linkToPLM}>
               <a target='_blank'
                  className={css.linkIconHref}
                  onClick={onOpenPlmPopup}>
                 <Link/>
               </a>
             </Tooltip2>
             {/*{popup == 'linkToPlm'*/}
             {/* ? (*/}
             {/*   <PLMSpecificationList*/}
             {/*     anchorEl={anchorEl}*/}
             {/*     libraryType={libraryType}*/}
             {/*     libraryId={id}*/}
             {/*     onClickPublishNew={() => this.popup = 'publishNew'}*/}
             {/*     isSeasonalLibrary={isSeasonalLibrary}*/}
             {/*     onClosePLMSpecificationList={onClosePopup}/>*/}
             {/* )*/}
             {/* : popup == 'publishNew'*/}
             {/*   ? (*/}
             {/*     PublishPLMSpecificationPopupComponent*/}
             {/*       onClickCancel={onClosePopup}*/}
             {/*       anchorEl={anchorEl}*/}
             {/*       data={data}*/}
             {/*       type={libraryType}*/}
             {/*       isSeasonalLibrary={isSeasonalLibrary}*/}
             {/*     />)*/}
             {/*   : null}*/}
           </Fragment>
  }
}



// WEBPACK FOOTER //
// ./src/modules/libraries/components/ExternalPlmLink.tsx